
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neat-vs-autoentry",
      function () {
        return require("private-next-pages/neat-vs-autoentry.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neat-vs-autoentry"])
      });
    }
  